import { InputSwitch } from '@creditornot/cb-switch';
import React from 'react';
import { Field } from 'react-final-form';
import { FormattedMessage, useIntl } from 'react-intl';

import { useOfferingMenuPermissionsContext } from 'modules/shared-menu/contexts/OfferingMenuPermissionsContext';

import { useRowOverrideContext } from './WithOverrideToggle';
import { BaseField } from './types';
import { useOfferOverridesContext } from '../../../context/OfferOverridesContext';
import { FormRowRenderer } from '../FormRowRenderer';
import { PreviewRowContainer } from '../OfferDetailsFormFields.styles';

export const Enabled = ({ sidePanelMode, offer }: BaseField) => {
  const menuPermissions = useOfferingMenuPermissionsContext();
  const intl = useIntl();

  const { maybeOverriddenOffer, getOfferAttrHasOverride } = useOfferOverridesContext();
  const { isOverrideToggleOn, isRowGroupEnabledForOverride } = useRowOverrideContext();

  const fieldNameToUse = isOverrideToggleOn ? 'enabledOverride' : 'enabled';

  const isEnabledAttributeOverridden = getOfferAttrHasOverride('enabled');

  const previewComponent = (
    <PreviewRowContainer>
      <FormattedMessage
        id={maybeOverriddenOffer?.enabled.enabled ? 'menu-item.enabled-true' : 'menu-item.enabled-false'}
      />
    </PreviewRowContainer>
  );

  const editComponent = (
    <Field name={fieldNameToUse}>
      {({ input }) => (
        <InputSwitch
          checked={!!input.value}
          onChange={() => {
            input.onChange(!input.value);
          }}
        />
      )}
    </Field>
  );

  return (
    <FormRowRenderer
      hasContentEditPermission={menuPermissions.contentEdit}
      label={intl.formatMessage({ id: 'menu-item.enabled' })}
      previewComponent={previewComponent}
      editComponent={editComponent}
      sidePanelMode={sidePanelMode}
      isOverridden={isEnabledAttributeOverridden}
      canBeOverridden={isRowGroupEnabledForOverride}
      offer={offer}
    />
  );
};
